export default function (context, {value, name, field, filter}) {
    let d = {};
    d.id = filter;
    d[field] = value;
    context.commit(name + '/filter_set', d);
}